import React, { Component } from "react";
import TradeDialog from "./TradeDialog.jsx";
import PropTypes from "prop-types";

export class TradeFormType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActionLoading: false,
      isActionTriggered: false,
      isDialogOpen: false,
    };
  }

  handleClickDialogOpen() {
    this.setState({
      isDialogOpen: true,
    });
  }

  handleClickDialogClose(event, reason) {
    if (reason && reason === "backdropClick") return;
    this.setState({
      isDialogOpen: false,
    });
  }

  render() {
    return (
      <div data-testid="trade-form-type-component">
        <span data-testid="trade-form-type-text-link" className="text-link" onClick={this.handleClickDialogOpen.bind(this)}>
          {this.props.trade.tradeFormType}
        </span>
        <TradeDialog
          loggedInUserData={this.props.loggedInUserData}
          trade={this.props.trade}
          isDialogOpen={this.state.isDialogOpen}
          handleClickDialogOpen={this.handleClickDialogOpen.bind(this)}
          handleClickDialogClose={this.handleClickDialogClose.bind(this)}
          isAdminPage={this.props.isAdminPage}
          eid={this.props.loggedInUserData.eid}
          isDesktopView={this.props.isDesktopView}
        />
      </div>
    );
  }
}

TradeFormType.propTypes = {
  loggedInUserData: PropTypes.object.isRequired,
  trade: PropTypes.object.isRequired,
  isAdminPage: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
};

export default TradeFormType;
